import DragAndDropFileUploader from "@app/shared/DragAndDropFileUploader";
import { FlyoutContext } from "@app/shared/Flyouts";
import { QESTextInput } from "@app/shared/qes-standards/forms/TextInput";
import TutorialsService from "@app/tutorials/tutorialsService";
import { FC, JSX, useContext, useRef, useState } from "react";

interface AddTutorialProps {
    container: string;
    fileExtensionSplitter: (filename: string) => [string, string];
    onUpload: (displayTitle: string, response: string) => void;
}

export const AddTutorialFlyout: FC<AddTutorialProps> = ({ container, fileExtensionSplitter, onUpload }: AddTutorialProps): JSX.Element => {
    const supportService = useRef(new TutorialsService()).current;
    const [title, setTitle] = useState("");
    const flyoutContext = useContext(FlyoutContext);

    return (
        <>
            <div className="form-group row">
                <div className="col-6">
                    <QESTextInput
                        label="Display Title:"
                        testId="tutorials__file-name-input"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTitle(e.target.value)}
                        value={title}
                    />
                </div>
            </div>

            <p className="mt-4">Select the file you want to upload.</p>
            <DragAndDropFileUploader
                apiKeyName="tutorialFile"
                displayName={title}
                onUpload={async (data: FormData) => {
                    return new Promise<void>(async (resolve, reject) => {
                        try {
                            const info: FormDataEntryValue = data.get("tutorialFile");
                            // FormDataEntryValue is File | string, but we're banking on it being a File
                            if (info instanceof File) {
                                if (info.size > 2000000000) {
                                    alert("File is too large to upload.");
                                    throw "file too large";
                                }
                                const [basename, extension] = fileExtensionSplitter(info.name);
                                const encodedTitle = encodeURIComponent(title);
                                const newDataStr = await supportService.updateBlobSas(container, basename, extension, encodedTitle, data);
                                onUpload(title, newDataStr);
                                flyoutContext.handleCloseFlyout();
                                resolve();
                            }
                        } catch (e) {
                            reject();
                        }
                    });
                }}
                disabled={title === ""}
                testId="tutorials__file-input"
            />
        </>
    );
}